import { SxProps, Theme } from "@mui/material";

export const containerStyles: SxProps = {
  marginY: "8px",
};

export const buttonStyles: SxProps<Theme> = (theme) => ({
  borderRadius: "24px",
  textTransform: "none",
  backgroundColor: theme.palette.panelInfo.button.bg,
  borderColor: "#06B6D4",
  color: "#06B6D4",
  fontWeight: 500,
  px: 4,
  py: 1.5,
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.button.bgHover,
    borderColor: "#06B6D4",
  },
});

export const messageContainerStyles: SxProps<Theme> = (theme) => ({
  background: theme.palette.panelInfo.message.bg,
  padding: "16px",
  borderRadius: "4px",
  cursor: "pointer",
  transition: "background-color 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.message.bgHover,
  },
});

export const textFieldSearchStyles: SxProps<Theme> = (theme) => ({
  "& .MuiOutlinedInput-root": {
    paddingY: "6px",
    borderRadius: "9999px",
    backgroundColor: theme.palette.panelInfo.panel.bg,
    "& fieldset": {
      borderColor: theme.palette.panelInfo.selector.borderColor,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.panelInfo.selector.borderColor,
    },
    "&.Mui-focused fieldset": {
      borderColor: "#06B6D4",
    },
    "& .MuiInputBase-input::placeholder": {
      color: theme.palette.panelInfo.selector.color,
    },
    "& .MuiOutlinedInput-input": {
      color: theme.palette.footer.textInput.color,
    },
  },
});
